import { useMutation, gql } from "@apollo/client";

export type Contract = {
  contractTemplateId: string,
  madId: string;
  filename: string;
  document: string;
  signingProcess: "docusign" | "manual";
};

export const INSERT_CONTRACT_TEMPLATE = gql`
  mutation createContract($input: CreateContractInput!) {
    createContract(input: $input) {
      contract {
        id
      }
    }
  }
`;

export default (options = {}) => {
  return useMutation<
    { createContract: { contract: { id: string } } },
    { input: Contract }
  >(INSERT_CONTRACT_TEMPLATE, options);
};
